import { Component, Input, OnInit } from '@angular/core';
import { Priority } from '../../../models/fraud-monitoring-tasks/Priority';
import { TaskPriorityEnumValues } from '../../../models/fraud-monitoring-tasks/enums/TaskPriorityEnumValues';

@Component({
  selector: 'app-fraud-monitoring-tasks-priority',
  standalone: false,
  templateUrl: './fraud-monitoring-tasks-priority.component.html'
})
export class FraudMonitoringTasksPriorityComponent implements OnInit {

  @Input({ required: true }) priority: Priority;
  priorityEnum = TaskPriorityEnumValues;

  constructor() { }

  ngOnInit() {
  }
}
